import React from 'react'
import PropTypes from 'prop-types'
import {
  Alert,
  Table,
  ContentSection,
  ContentSectionBlock,
  Card,
  ButtonContainer,
  Button
} from 'camino-react'

import { cloudhelpPatch, cloudhelpGet } from 'Utilities/CloudHelp'
import Modal from 'Components/Modal'

class AssignMajorIncident extends React.Component {
  constructor (props) {
    super(props)

    this.state = {
      loading: false,
      data: [],
      showModal: false,
      submitButtonDisabled: false,
      submitButtonText: 'Confirm',
      hasErrors: false,
      errorText: ''
    }

    this.submit = this.submit.bind(this)
  }

  submit () {
    const { paths } = this.props
    const { majorIncidentManagerId } = this.state
    const { problemPath } = paths

    this.setState({
      submitButtonText: 'Confirming...',
      submitButtonDisabled: true,
      hasErrors: false
    })

    const patchData = {
      problem: { major_incident_manager_id: majorIncidentManagerId }
    }

    cloudhelpPatch(problemPath, patchData)
      .then((response) => {
        window.location.href = response.data.redirect_url
        this.setState({
          submitButtonText: 'Confirmed',
          submitButtonDisabled: false
        })
      })
      .catch((error) => {
        const errorText = error.response.status === 422 ? error.response.data.errors.join(', ') : 'There was an issue assigning this problem.'

        this.setState({
          submitButtonText: 'Confirm',
          submitButtonDisabled: false,
          errorText,
          hasErrors: true
        })
      })
  }

  render () {
    const {
      hasErrors,
      errorText,
      showModal,
      majorIncidentManagerName,
      submitButtonText,
      submitButtonDisabled
    } = this.state

    const {
      majorIncidentManagers: data
    } = this.props

    const columns = [
      { text: 'Name', accessor: 'name' },
      { text: 'Email', accessor: 'email' },
      { text: 'Work phones', accessor: 'work_phones' },
      { text: 'Mobile phone', accessor: 'mobile_phone' },
      {
        text: '',
        accessor: '',
        Cell: row => (
          <Button
            onClick={() => {
              this.setState({
                showModal: true,
                majorIncidentManagerId: row.original.id,
                majorIncidentManagerName: row.original.name
              })
            }}
          >
            Assign manager
          </Button>
        )
      }
    ]

    return (
      <div>
        {hasErrors && <Alert title={errorText} type="error" />}
        <Alert title="Problem created" text={errorText} type="info">
          You must now assign a major incident manager to this problem.
        </Alert>
        <ContentSection card>
          <ContentSectionBlock title="Assign a major incident manager">
            <div className="row">
              <div className="col">
                {/* TODO: Needs to be implemented with Camino the section bellow */}
                <ol className="horizontal-list">
                  <li>
                    <p>
                      <strong>
                        Contact member
                        {' '}
                      </strong>
                      <span>
                        Contact a member of the major incident management team, starting from the top of the list.
                      </span>
                    </p>
                  </li>
                  <li>
                    <p>
                      <strong>
                        Confirm immediate response
                        {' '}
                      </strong>
                      <span>
                        They must be in a position to manage the issue within 15 minutes.
                        If not, try the next person on the list.
                      </span>
                    </p>
                  </li>
                  <li>
                    <p>
                      <strong>
                        Assign manager
                        {' '}
                      </strong>
                      <span>
                        Assign major incident manager.
                        This will send out notifications of to all staff informing them of this problem.
                      </span>
                    </p>
                  </li>
                </ol>
                <br />

                <div className="row">
                  <div className="col">
                    <Table
                      {...this.props}
                      data={data}
                      columns={columns}
                      noDataText="There are no managers to deal with this major incident"
                      localStoragePrefix="AssignMajorIncident"
                    />
                  </div>
                </div>
              </div>
            </div>
          </ContentSectionBlock>
        </ContentSection>
        <Modal showModal={showModal} title="Please confirm" info removeModal={() => { this.setState({ showModal: false }) }}>
          <Card flat padding="xsmall">
            <p style={{ fontSize: '18px' }}>
              {'You are about to assign '}
              <strong>
                {majorIncidentManagerName}
              </strong>
              {' as Major incident manager. Please confirm they can provide an immediate response.'}
            </p>
          </Card>
          <ButtonContainer center spaced>
            <Button color="dark" outline onClick={() => { this.setState({ showModal: false }) }}>
              Cancel
            </Button>
            <Button onClick={() => this.submit()} disabled={submitButtonDisabled}>
              {submitButtonText}
            </Button>
          </ButtonContainer>
        </Modal>
      </div>
    )
  }
}

AssignMajorIncident.propTypes = {
  paths: PropTypes.shape({
    problemPath: PropTypes.string.isRequired,
    apiUsersPath: PropTypes.string.isRequired
  }).isRequired
}

export default AssignMajorIncident
